<h3 [innerHTML]="profileIntroText.heading"></h3>
<div [innerHTML]="profileIntroText.mainText" class="id37-text2 text-light"></div>
